export { getFileContentTypeInfo, type FileContentTypeInfo } from "@msuite/utils/files";
